module.exports = __webpack_public_path__ + "img/psycho.a8e3dcd4.png";